<template>
	<div id="investmentdata">
		<headerbar></headerbar>
		<div class="bluebanner" v-title data-title="中投顾问-招商数据">
			<div class="centerpage1">
				<h2 class="title">招商数据</h2>
				<p>重点行业市场规模数据，以及专业团队市场机会评估分析。</p>
			</div>
		</div>
		<div class="opport-screen-list">
			<dl class="opport-screen">
				<dt class="fl">行业分类</dt>
				<dd class="fl">
					<span :class="categoryid == 0?'current a-screen':'a-screen'">全部</span>
					<span v-for="(list,index) in cetagroylist" 
						@click="showsecondlist(list.categoryid);categoryid =list.categoryid;"
						:class="list.categoryid == categoryid?'a-screen current' : 'a-screen'">{{list.category}}</span>
				</dd>
			</dl>
			<dl class="opport-screen" v-if="secondlist.length!=0">
				<dt class="fl">二级分类</dt>
				<dd class="fl">
					<span :class="categoryid1 == 0?'current a-screen':'a-screen'">全部</span>
					<span v-for="(list,index) in secondlist"
						@click="showthirdlist(list.categoryid);categoryid1=list.categoryid;" :data="list.categoryid"
						:class=" list.categoryid == categoryid1 ?'a-screen current' : 'a-screen'">{{list.name}}</span>
				</dd>
			</dl>
			<div class="opport_chain_screen" v-if="thirdclist.length!=0">
				<dl class="opport-screen ">
					<dt class="fl">产业链</dt>
					<dd class="fl">
						<span v-for="(list,index) in thirdclist" :data="list.id" :class="list.id == chainid ?'current a-screen':'a-screen'" @click="chainidshow(list.id);">
							{{list.name}}
						</span>
					</dd>
				</dl>
			</div>
		</div>
		<div class="chain_map oh centerpage1">
			<h3 class="title">全国智能电网产业地图</h3>
			<div class="poabox">
				<div class="echartBox" id="chain_map_provience"><img src="/dist/img/chainmap.fd789e25.png" alt="" style="display: block;margin: 10px auto;"></div> 
				<div id="chain_map_city"></div>
			</div>
			<h4 class="title chain_map_title fl">全国智能电网产业地图</h4>
			<div class="fl chain_map_font"><h5 class="smtitle">疫苗</h5><p><strong>重庆市：</strong><a href="/company/detail/300122" target="_blank">智飞生物</a></p><p><strong>昆明市：</strong><a href="/company/detail/300142" target="_blank">沃森生物</a></p><p><strong>新乡市：</strong><a href="/company/detail/002007" target="_blank">华兰生物</a></p></div><div class="fl chain_map_font"><h5 class="smtitle">血液制品</h5><p><strong>北京市：</strong><a href="/company/detail/600161" target="_blank">天坛生物</a>，<a href="/company/detail/700923" target="_blank">中国生物</a></p><p><strong>深圳市：</strong><a href="/company/detail/002880" target="_blank">卫光生物</a></p><p><strong>上海市：</strong><a href="/company/detail/002252" target="_blank">上海莱士</a></p></div><div class="fl chain_map_font"><h5 class="smtitle">重组蛋白</h5><p><strong>无锡市：</strong><a href="/company/detail/000518" target="_blank">四环生物</a></p><p><strong>海口市：</strong><a href="/company/detail/002693" target="_blank">双成药业</a></p><p><strong>合肥市：</strong><a href="/company/detail/300009" target="_blank">安科生物</a></p></div><div class="fl chain_map_font"><h5 class="smtitle">单克隆抗体</h5><p><strong>上海市：</strong><a href="/company/detail/833330" target="_blank">君实生物</a></p><p><strong>苏州市：</strong><a href="/company/detail/701967" target="_blank">信达生物</a></p></div><div class="fl chain_map_font"><h5 class="smtitle">诊断类</h5><p><strong>绍兴市：</strong><a href="/company/detail/600216" target="_blank">浙江医药</a>，<a href="/company/detail/002001" target="_blank">新和成</a>，<a href="/company/detail/002020" target="_blank">京新药业</a></p><p><strong>台州市：</strong><a href="/company/detail/600521" target="_blank">华海药业</a>，<a href="/company/detail/600267" target="_blank">海正药业</a>，<a href="/company/detail/002099" target="_blank">海翔药业</a></p><p><strong>广州市：</strong><a href="/company/detail/002030" target="_blank">达安基因</a>，<a href="/company/detail/300482" target="_blank">万孚生物</a></p></div><div class="fl chain_map_font"><h5 class="smtitle">药店</h5><p><strong>上海市：</strong><a href="/company/detail/700354" target="_blank">国大药房</a>，<a href="/company/detail/700620" target="_blank">华氏大药房</a></p><p><strong>昆明市：</strong><a href="/company/detail/002727" target="_blank">一心堂</a></p><p><strong>常德市：</strong><a href="/company/detail/603939" target="_blank">益丰药房</a></p></div><div class="fl chain_map_font"><h5 class="smtitle">植物原料</h5><p><strong>昆明市：</strong><a href="/company/detail/000538" target="_blank">云南白药</a></p><p><strong>揭阳市：</strong><a href="/company/detail/600518" target="_blank">康美药业</a></p><p><strong>通化市：</strong><a href="/company/detail/002118" target="_blank">紫鑫药业</a></p></div><div class="fl chain_map_font"><h5 class="smtitle">微生物原料</h5><p><strong>汉中市：</strong><a href="/company/detail/833760" target="_blank">天然谷</a></p><p><strong>桂林市：</strong><a href="/company/detail/002166" target="_blank">莱茵生物</a></p><p><strong>成都市：</strong><a href="/company/detail/833230" target="_blank">欧康医药</a></p></div><div class="fl chain_map_font"><h5 class="smtitle">动物原料</h5><p><strong>云浮市：</strong><a href="/company/detail/300498" target="_blank">温氏股份</a></p><p><strong>哈尔滨市：</strong><a href="/company/detail/704593" target="_blank">天蓬居</a></p><p><strong>邯郸市：</strong><a href="/company/detail/704677" target="_blank">超翔养殖</a></p></div><div class="fl chain_map_font"><h5 class="smtitle">超市</h5><p><strong>福州市：</strong><a href="/company/detail/601933" target="_blank">永辉超市</a></p><p><strong>深圳市：</strong><a href="/company/detail/704840" target="_blank">华润万家</a>，<a href="/company/detail/705753" target="_blank">富家欢</a></p><p><strong>上海市：</strong><a href="/company/detail/705058" target="_blank">康成投资</a></p></div><div class="fl chain_map_font"><h5 class="smtitle">医院</h5><p><strong>北京市：</strong><a href="/company/detail/700447" target="_blank">北京大学第六医院</a>，<a href="/company/detail/700457" target="_blank">煤炭总医院</a>，<a href="/company/detail/701147" target="_blank">北京大学人民医院</a>，<a href="/company/detail/701305" target="_blank">北京医院</a></p></div>

		</div>
		<div class="opport_market centerpage1">
			<h3 class="title">产业链重点公司</h3> 
			<table width="100%" border="0" cellspacing="0" cellpadding="0">
				<tr class="tac tabletitle1">
					<th>企业名称</th>
					<th>所有制</th>
					<th>类型</th>
					<th>行业地位</th>
					<th>发展阶段</th>
					<th>经营情况</th>
					<th>竞争力</th>
					<th>成长性</th>
					<th>投资意愿</th>
					<th>投资能力</th>
					<th>招商机会</th> 
			</tr>
			<tr class="opprthtd">
			<td><span><a href="/company/detail/300498" target="_blank">温氏股份</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>行业龙头</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>很强</span></td>
				<td><span>较大</span></td>
				<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td> 
			</tr>
			<tr class="opprthtd">
				<td><span><a href="/company/detail/000538" target="_blank">云南白药</a></span></td>
				<td><span>民企</span></td>
				<td><span>中国500强, 上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>很好</span></td>
				<td><span>很强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/600518" target="_blank">康美药业</a></span></td>
				<td><span>民企</span></td>
				<td><span>中国500强, 上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>成熟期</span></td>
				<td><span>正常</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/002118" target="_blank">紫鑫药业</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/300534" target="_blank">陇神戎发</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>普通</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/703389" target="_blank">同仁堂</a></span></td>
				<td><span>国企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>成熟期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>普通</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/833760" target="_blank">天然谷</a></span></td>
				<td><span>国企</span></td>
				<td><span>其他</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/002166" target="_blank">莱茵生物</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>行业龙头</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/833230" target="_blank">欧康医药</a></span></td>
				<td><span>民企</span></td>
				<td><span>其他</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/600298" target="_blank">安琪酵母</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>行业龙头</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>很强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/300122" target="_blank">智飞生物</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/300142" target="_blank">沃森生物</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/002007" target="_blank">华兰生物</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/600161" target="_blank">天坛生物</a></span></td>
				<td><span>国企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>普通</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/700070" target="_blank">长春所</a></span></td>
				<td><span>国企</span></td>
				<td><span>其他</span></td>
				<td><span>专精特新</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/700143" target="_blank">兰州所</a></span></td>
				<td><span>央企</span></td>
				<td><span>世界500强</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/700919" target="_blank">雅立峰生物</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/701257" target="_blank">成都所</a></span></td>
				<td><span>央企</span></td>
				<td><span>世界500强</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/705072" target="_blank">科兴生物制药</a></span></td>
				<td><span>民企</span></td>
				<td><span>其他</span></td>
				<td><span>专精特新</span></td>
				<td><span>成长期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/833330" target="_blank">君实生物</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>专精特新</span></td>
				<td><span>成长期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>很大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/701967" target="_blank">信达生物</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>专精特新</span></td>
				<td><span>成长期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>很大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/002880" target="_blank">卫光生物</a></span></td>
				<td><span>国企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/002252" target="_blank">上海莱士</a></span></td>
				<td><span>其他</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>成熟期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>普通</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/000403" target="_blank">双林生物</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>成熟期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>普通</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/300294" target="_blank">博雅生物</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/700923" target="_blank">中国生物</a></span></td>
				<td><span>央企</span></td>
				<td><span>世界500强</span></td>
				<td><span>行业龙头</span></td>
				<td><span>扩张期</span></td>
				<td><span>很好</span></td>
				<td><span>很强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/000518" target="_blank">四环生物</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>成熟期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>普通</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/002693" target="_blank">双成药业</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>成熟期</span></td>
				<td><span>正常</span></td>
				<td><span>较强</span></td>
				<td><span>普通</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/300009" target="_blank">安科生物</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>行业龙头</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/701666" target="_blank">翰宇生物</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/002030" target="_blank">达安基因</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/600216" target="_blank">浙江医药</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/002001" target="_blank">新和成</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/002020" target="_blank">京新药业</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/600521" target="_blank">华海药业</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/600267" target="_blank">海正药业</a></span></td>
				<td><span>国企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/002099" target="_blank">海翔药业</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/002019" target="_blank">亿帆医药</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/002626" target="_blank">金达威</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/002399" target="_blank">海普瑞</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/300676" target="_blank">华大基因</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>行业龙头</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>很强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/000756" target="_blank">新华制药</a></span></td>
				<td><span>国企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/300233" target="_blank">金城医药</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/000739" target="_blank">普洛药业</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/300482" target="_blank">万孚生物</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/000597" target="_blank">东北制药</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/000710" target="_blank">贝瑞基因</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/002727" target="_blank">一心堂</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/603939" target="_blank">益丰药房</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>行业龙头</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>很强</span></td>
				<td><span>很大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/603883" target="_blank">老百姓</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/603233" target="_blank">大参林</a></span></td>
				<td><span>民企</span></td>
				<td><span>上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr> <tr class="opprthtd">
				<td><span><a href="/company/detail/700354" target="_blank">国大药房</a></span></td>
				<td><span>央企</span></td>
				<td><span>其他</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>较好</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr><tr class="opprthtd">
				<td><span><a href="/company/detail/601933" target="_blank">永辉超市</a></span></td>
				<td><span>民企</span></td>
				<td><span>中国500强, 上市公司</span></td>
				<td><span>重点企业</span></td>
				<td><span>扩张期</span></td>
				<td><span>很好</span></td>
				<td><span>很强</span></td>
				<td><span>较大</span></td>
			<td><span>较强</span></td>
				<td><span>较强</span></td>
				<td><span>较大</span></td>
			</tr>
			</table>
		</div>




		<footerbar></footerbar>
	</div>
</template>

<script>
	var datalist2 = [],
		datalist3 = [];
	var datalist1 = [{
			categoryid: 10560,
			category: "大健康",
			data: [{
					name: "医疗",
					categoryid: 123031,
					chaindata: [{
							id: 123018,
							name: "智慧医疗"
						}, {
							id: 12773012,
							name: "康复医疗"
						},
						{
							id: 123013,
							name: "基因检测"
						}, {
							id: 1230184,
							name: "医疗美容"
						}, {
							id: 123015,
							name: "口腔医疗"
						}, {
							id: 123019,
							name: "互联网医疗"
						},
						{
							id: 1230912,
							name: "辅助生殖"
						}, {
							id: 1230193,
							name: "医疗大数据"
						}, {
							id: 1230414,
							name: "干细胞治疗"
						}, {
							id: 1230183,
							name: "远程医疗"
						},
						{
							id: 123014,
							name: "宠物医疗"
						}, {
							id: 1230175,
							name: "医疗废品处理 "
						}, {
							id: 1230120,
							name: "独立医学实验服务 "
						}, {
							id: 123012,
							name: "医疗信息化"
						}, {
							id: 1230913,
							name: "远程医疗"
						}
					]
				},
				{
					name: "医疗器械",
					categoryid: 123041,
					chaindata: [{
							id: 1230126,
							name: "智慧医疗1"
						}, {
							id: 12773012,
							name: "康复医疗1"
						},
						{
							id: 123013,
							name: "基因检测1"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗"
						}, {
							id: 1230148,
							name: "互联网医疗1"
						},
						{
							id: 123012,
							name: "辅助生殖1"
						}, {
							id: 1230193,
							name: "医疗大数据1"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗1"
						},
						{
							id: 123014,
							name: "宠物医疗1"
						}, {
							id: 1230175,
							name: "医疗废品处理1 "
						}, {
							id: 1230149,
							name: "独立医学实验服务1 "
						}, {
							id: 123012,
							name: "医疗信息化1"
						}, {
							id: 1230913,
							name: "远程医疗1"
						}
					]
				},
				{
					name: "养老保健",
					categoryid: 123051,
					chaindata: [{
							id: 1230150,
							name: "智慧医2"
						}, {
							id: 12773012,
							name: "康复医疗12"
						},
						{
							id: 123013,
							name: "基因检测12"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗2"
						}, {
							id: 1230151,
							name: "互联网医疗12"
						},
						{
							id: 123012,
							name: "辅助生殖12"
						}, {
							id: 1230193,
							name: "医疗大数据12"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗12"
						},
						{
							id: 123014,
							name: "宠物医疗12"
						}, {
							id: 1230175,
							name: "医疗废品处理12 "
						}, {
							id: 1230152,
							name: "独立医学实验服务12 "
						}, {
							id: 123012,
							name: "医疗信息化1"
						}, {
							id: 1230913,
							name: "远程医疗21"
						}
					]
				},
				{
					name: "医药",
					categoryid: 123061,
					chaindata: [{
							id: 1230153,
							name: "智慧医23"
						}, {
							id: 12773012,
							name: "康复医疗123"
						},
						{
							id: 123013,
							name: "基因检测123"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗2"
						}, {
							id: 1230154,
							name: "互联网医疗123"
						},
						{
							id: 123012,
							name: "辅助生殖123"
						}, {
							id: 1230193,
							name: "医疗大数据12"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗12"
						},
						{
							id: 123014,
							name: "宠物医疗123"
						}, {
							id: 1230153,
							name: "医疗废品处理123 "
						}, {
							id: 1230155,
							name: "独立医学实验服务123 "
						}, {
							id: 123012,
							name: "医疗信息化13"
						}, {
							id: 1230913,
							name: "远程医疗213"
						}
					]
				},
			]
		},
		{
			categoryid: 10561,
			category: "信息技术",
			data: [{
					name: "医疗a",
					categoryid: 123031,
					chaindata: [{
							id: 1230181,
							name: "智慧医疗"
						}, {
							id: 12773012,
							name: "康复医疗"
						},
						{
							id: 123013,
							name: "基因检测"
						}, {
							id: 1230184,
							name: "医疗美容"
						}, {
							id: 123015,
							name: "口腔医疗"
						}, {
							id: 1230182,
							name: "互联网医疗"
						},
						{
							id: 1230912,
							name: "辅助生殖"
						}, {
							id: 1230193,
							name: "医疗大数据"
						}, {
							id: 1230414,
							name: "干细胞治疗"
						}, {
							id: 1230183,
							name: "远程医疗"
						},
						{
							id: 123014,
							name: "宠物医疗"
						}, {
							id: 1230175,
							name: "医疗废品处理 "
						}, {
							id: 1230183,
							name: "独立医学实验服务 "
						}, {
							id: 123012,
							name: "医疗信息化"
						}, {
							id: 1230913,
							name: "远程医疗"
						}
					]
				},
				{
					name: "医疗器械a",
					categoryid: 123041,
					chaindata: [{
							id: 1230184,
							name: "智慧医疗1"
						}, {
							id: 12773012,
							name: "康复医疗1"
						},
						{
							id: 123013,
							name: "基因检测1"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗"
						}, {
							id: 1230185,
							name: "互联网医疗1"
						},
						{
							id: 123012,
							name: "辅助生殖1"
						}, {
							id: 1230193,
							name: "医疗大数据1"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗1"
						},
						{
							id: 123014,
							name: "宠物医疗1"
						}, {
							id: 1230175,
							name: "医疗废品处理1 "
						}, {
							id: 1230186,
							name: "独立医学实验服务1 "
						}, {
							id: 123012,
							name: "医疗信息化1"
						}, {
							id: 1230913,
							name: "远程医疗1"
						}
					]
				},
				{
					name: "养老保健a",
					categoryid: 123051,
					chaindata: [{
							id: 1230187,
							name: "智慧医2"
						}, {
							id: 12773012,
							name: "康复医疗12"
						},
						{
							id: 123013,
							name: "基因检测12"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗2"
						}, {
							id: 1230188,
							name: "互联网医疗12"
						},
						{
							id: 123012,
							name: "辅助生殖12"
						}, {
							id: 1230193,
							name: "医疗大数据12"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗12"
						},
						{
							id: 123014,
							name: "宠物医疗12"
						}, {
							id: 1230175,
							name: "医疗废品处理12 "
						}, {
							id: 1230189,
							name: "独立医学实验服务12 "
						}, {
							id: 123012,
							name: "医疗信息化1"
						}, {
							id: 1230913,
							name: "远程医疗21"
						}
					]
				},
				{
					name: "医药a",
					categoryid: 123061,
					chaindata: [{
							id: 1230190,
							name: "智慧医23"
						}, {
							id: 12773012,
							name: "康复医疗123"
						},
						{
							id: 123013,
							name: "基因检测123"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗2"
						}, {
							id: 1230191,
							name: "互联网医疗123"
						},
						{
							id: 123012,
							name: "辅助生殖123"
						}, {
							id: 1230193,
							name: "医疗大数据12"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗12"
						},
						{
							id: 123014,
							name: "宠物医疗123"
						}, {
							id: 1230153,
							name: "医疗废品处理123 "
						}, {
							id: 1230192,
							name: "独立医学实验服务123 "
						}, {
							id: 123012,
							name: "医疗信息化13"
						}, {
							id: 1230913,
							name: "远程医疗213"
						}
					]
				},
			]
		},
		{
			categoryid: 10562,
			category: "高端制造",
			data: [{
					name: "医疗ab",
					categoryid: 123031,
					chaindata: [{
							id: 1230193,
							name: "智慧医疗"
						}, {
							id: 12773012,
							name: "康复医疗"
						},
						{
							id: 123013,
							name: "基因检测"
						}, {
							id: 1230184,
							name: "医疗美容"
						}, {
							id: 123015,
							name: "口腔医疗"
						}, {
							id: 1230194,
							name: "互联网医疗"
						},
						{
							id: 1230912,
							name: "辅助生殖"
						}, {
							id: 1230193,
							name: "医疗大数据"
						}, {
							id: 1230414,
							name: "干细胞治疗"
						}, {
							id: 1230183,
							name: "远程医疗"
						},
						{
							id: 123014,
							name: "宠物医疗"
						}, {
							id: 1230175,
							name: "医疗废品处理 "
						}, {
							id: 1230195,
							name: "独立医学实验服务 "
						}, {
							id: 123012,
							name: "医疗信息化"
						}, {
							id: 1230913,
							name: "远程医疗"
						}
					]
				},
				{
					name: "医疗器械ba",
					categoryid: 123041,
					chaindata: [{
							id: 1230196,
							name: "智慧医疗1"
						}, {
							id: 12773012,
							name: "康复医疗1"
						},
						{
							id: 123013,
							name: "基因检测1"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗"
						}, {
							id: 1230197,
							name: "互联网医疗1"
						},
						{
							id: 123012,
							name: "辅助生殖1"
						}, {
							id: 1230193,
							name: "医疗大数据1"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗1"
						},
						{
							id: 123014,
							name: "宠物医疗1"
						}, {
							id: 1230175,
							name: "医疗废品处理1 "
						}, {
							id: 1230199,
							name: "独立医学实验服务1 "
						}, {
							id: 123012,
							name: "医疗信息化1"
						}, {
							id: 1230913,
							name: "远程医疗1"
						}
					]
				},
				{
					name: "养老保健ab",
					categoryid: 123051,
					chaindata: [{
							id: 1230198,
							name: "智慧医2"
						}, {
							id: 12773012,
							name: "康复医疗12"
						},
						{
							id: 123013,
							name: "基因检测12"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗2"
						}, {
							id: 1230178,
							name: "互联网医疗12"
						},
						{
							id: 123012,
							name: "辅助生殖12"
						}, {
							id: 1230193,
							name: "医疗大数据12"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗12"
						},
						{
							id: 123014,
							name: "宠物医疗12"
						}, {
							id: 1230175,
							name: "医疗废品处理12 "
						}, {
							id: 1230177,
							name: "独立医学实验服务12 "
						}, {
							id: 123012,
							name: "医疗信息化1"
						}, {
							id: 1230913,
							name: "远程医疗21"
						}
					]
				},
				{
					name: "医药ab",
					categoryid: 123061,
					chaindata: [{
							id: 1230176,
							name: "智慧医23"
						}, {
							id: 12773012,
							name: "康复医疗123"
						},
						{
							id: 123013,
							name: "基因检测123"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗2"
						}, {
							id: 1230175,
							name: "互联网医疗123"
						},
						{
							id: 123012,
							name: "辅助生殖123"
						}, {
							id: 1230193,
							name: "医疗大数据12"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗12"
						},
						{
							id: 123014,
							name: "宠物医疗123"
						}, {
							id: 1230153,
							name: "医疗废品处理123 "
						}, {
							id: 1230174,
							name: "独立医学实验服务123 "
						}, {
							id: 123012,
							name: "医疗信息化13"
						}, {
							id: 1230913,
							name: "远程医疗213"
						}
					]
				},
			]
		},
		{
			categoryid: 10563,
			category: "能源环保材料",
			data: [{
					name: "医疗va",
					categoryid: 123031,
					chaindata: [{
							id: 1230173,
							name: "智慧医疗"
						}, {
							id: 12773012,
							name: "康复医疗"
						},
						{
							id: 123013,
							name: "基因检测"
						}, {
							id: 1230184,
							name: "医疗美容"
						}, {
							id: 123015,
							name: "口腔医疗"
						}, {
							id: 1230172,
							name: "互联网医疗"
						},
						{
							id: 1230912,
							name: "辅助生殖"
						}, {
							id: 1230193,
							name: "医疗大数据"
						}, {
							id: 1230414,
							name: "干细胞治疗"
						}, {
							id: 1230183,
							name: "远程医疗"
						},
						{
							id: 123014,
							name: "宠物医疗"
						}, {
							id: 1230175,
							name: "医疗废品处理 "
						}, {
							id: 1230171,
							name: "独立医学实验服务 "
						}, {
							id: 123012,
							name: "医疗信息化"
						}, {
							id: 1230913,
							name: "远程医疗"
						}
					]
				},
				{
					name: "医疗器械va",
					categoryid: 123041,
					chaindata: [{
							id: 1230170,
							name: "智慧医疗1"
						}, {
							id: 12773012,
							name: "康复医疗1"
						},
						{
							id: 123013,
							name: "基因检测1"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗"
						}, {
							id: 1230169,
							name: "互联网医疗1"
						},
						{
							id: 1230912,
							name: "辅助生殖1"
						}, {
							id: 1230193,
							name: "医疗大数据1"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗1"
						},
						{
							id: 123014,
							name: "宠物医疗1"
						}, {
							id: 1230175,
							name: "医疗废品处理1 "
						}, {
							id: 1230168,
							name: "独立医学实验服务1 "
						}, {
							id: 123012,
							name: "医疗信息化1"
						}, {
							id: 1230913,
							name: "远程医疗1"
						}
					]
				},
				{
					name: "养老保健va",
					categoryid: 123051,
					chaindata: [{
							id: 1230167,
							name: "智慧医2"
						}, {
							id: 12773012,
							name: "康复医疗12"
						},
						{
							id: 123013,
							name: "基因检测12"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗2"
						}, {
							id: 1230166,
							name: "互联网医疗12"
						},
						{
							id: 1230912,
							name: "辅助生殖12"
						}, {
							id: 1230193,
							name: "医疗大数据12"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗12"
						},
						{
							id: 123014,
							name: "宠物医疗12"
						}, {
							id: 1230175,
							name: "医疗废品处理12 "
						}, {
							id: 1230165,
							name: "独立医学实验服务12 "
						}, {
							id: 123012,
							name: "医疗信息化1"
						}, {
							id: 1230913,
							name: "远程医疗21"
						}
					]
				},
				{
					name: "医药va",
					categoryid: 123061,
					chaindata: [{
							id: 1230164,
							name: "智慧医23"
						}, {
							id: 12773012,
							name: "康复医疗123"
						},
						{
							id: 123013,
							name: "基因检测123"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗2"
						}, {
							id: 1230163,
							name: "互联网医疗123"
						},
						{
							id: 1230912,
							name: "辅助生殖123"
						}, {
							id: 1230193,
							name: "医疗大数据12"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗12"
						},
						{
							id: 123014,
							name: "宠物医疗123"
						}, {
							id: 1230153,
							name: "医疗废品处理123 "
						}, {
							id: 1230162,
							name: "独立医学实验服务123 "
						}, {
							id: 123012,
							name: "医疗信息化13"
						}, {
							id: 1230913,
							name: "远程医疗213"
						}
					]
				},
			]
		},
		{
			categoryid: 10637,
			category: "现代服务业",
			data: [{
					name: "医疗vac",
					categoryid: 123031,
					chaindata: [{
							id: 1230161,
							name: "智慧医疗"
						}, {
							id: 12773012,
							name: "康复医疗"
						},
						{
							id: 123013,
							name: "基因检测"
						}, {
							id: 1230184,
							name: "医疗美容"
						}, {
							id: 123015,
							name: "口腔医疗"
						}, {
							id: 1230160,
							name: "互联网医疗"
						},
						{
							id: 1230912,
							name: "辅助生殖"
						}, {
							id: 1230193,
							name: "医疗大数据"
						}, {
							id: 1230414,
							name: "干细胞治疗"
						}, {
							id: 1230183,
							name: "远程医疗"
						},
						{
							id: 123014,
							name: "宠物医疗"
						}, {
							id: 1230175,
							name: "医疗废品处理 "
						}, {
							id: 1230159,
							name: "独立医学实验服务 "
						}, {
							id: 123012,
							name: "医疗信息化"
						}, {
							id: 1230913,
							name: "远程医疗"
						}
					]
				},
				{
					name: "医疗器械vca",
					categoryid: 123041,
					chaindata: [{
							id: 1230158,
							name: "智慧医疗1"
						}, {
							id: 12773012,
							name: "康复医疗1"
						},
						{
							id: 123013,
							name: "基因检测1"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗"
						}, {
							id: 1230157,
							name: "互联网医疗1"
						},
						{
							id: 1230912,
							name: "辅助生殖1"
						}, {
							id: 1230193,
							name: "医疗大数据1"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗1"
						},
						{
							id: 123014,
							name: "宠物医疗1"
						}, {
							id: 1230175,
							name: "医疗废品处理1 "
						}, {
							id: 1230156,
							name: "独立医学实验服务1 "
						}, {
							id: 123012,
							name: "医疗信息化1"
						}, {
							id: 1230913,
							name: "远程医疗1"
						}
					]
				},
				{
					name: "养老保健avc",
					categoryid: 123051,
					chaindata: [{
							id: 1230155,
							name: "智慧医2"
						}, {
							id: 12773012,
							name: "康复医疗12"
						},
						{
							id: 123013,
							name: "基因检测12"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗2"
						}, {
							id: 1230154,
							name: "互联网医疗12"
						},
						{
							id: 1230912,
							name: "辅助生殖12"
						}, {
							id: 1230193,
							name: "医疗大数据12"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗12"
						},
						{
							id: 123014,
							name: "宠物医疗12"
						}, {
							id: 1230175,
							name: "医疗废品处理12 "
						}, {
							id: 1230153,
							name: "独立医学实验服务12 "
						}, {
							id: 123012,
							name: "医疗信息化1"
						}, {
							id: 1230913,
							name: "远程医疗21"
						}
					]
				},
				{
					name: "医药vac",
					categoryid: 123061,
					chaindata: [{
							id: 1230152,
							name: "智慧医23"
						}, {
							id: 12773012,
							name: "康复医疗123"
						},
						{
							id: 123013,
							name: "基因检测123"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗2"
						}, {
							id: 1230151,
							name: "互联网医疗123"
						},
						{
							id: 1230912,
							name: "辅助生殖123"
						}, {
							id: 1230193,
							name: "医疗大数据12"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗12"
						},
						{
							id: 123014,
							name: "宠物医疗123"
						}, {
							id: 1230153,
							name: "医疗废品处理123 "
						}, {
							id: 1230152,
							name: "独立医学实验服务123 "
						}, {
							id: 123012,
							name: "医疗信息化13"
						}, {
							id: 1230913,
							name: "远程医疗213"
						}
					]
				},
			]
		},
		{
			categoryid: 10644,
			category: "大消费",
			data: [{
					name: "医疗as",
					categoryid: 123031,
					chaindata: [{
							id: 1230171,
							name: "智慧医疗"
						}, {
							id: 12773012,
							name: "康复医疗"
						},
						{
							id: 123013,
							name: "基因检测"
						}, {
							id: 1230184,
							name: "医疗美容"
						}, {
							id: 123015,
							name: "口腔医疗"
						}, {
							id: 1230121,
							name: "互联网医疗"
						},
						{
							id: 1230912,
							name: "辅助生殖"
						}, {
							id: 1230193,
							name: "医疗大数据"
						}, {
							id: 1230414,
							name: "干细胞治疗"
						}, {
							id: 1230183,
							name: "远程医疗"
						},
						{
							id: 123014,
							name: "宠物医疗"
						}, {
							id: 1230175,
							name: "医疗废品处理 "
						}, {
							id: 1230181,
							name: "独立医学实验服务 "
						}, {
							id: 123012,
							name: "医疗信息化"
						}, {
							id: 1230913,
							name: "远程医疗"
						}
					]
				},
				{
					name: "医疗器械as",
					categoryid: 123041,
					chaindata: [{
							id: 1230191,
							name: "智慧医疗1"
						}, {
							id: 12773012,
							name: "康复医疗1"
						},
						{
							id: 123013,
							name: "基因检测1"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗"
						}, {
							id: 12301811,
							name: "互联网医疗1"
						},
						{
							id: 1230912,
							name: "辅助生殖1"
						}, {
							id: 1230193,
							name: "医疗大数据1"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗1"
						},
						{
							id: 123014,
							name: "宠物医疗1"
						}, {
							id: 1230175,
							name: "医疗废品处理1 "
						}, {
							id: 1230161,
							name: "独立医学实验服务1 "
						}, {
							id: 123012,
							name: "医疗信息化1"
						}, {
							id: 1230913,
							name: "远程医疗1"
						}
					]
				},
				{
					name: "养老保健sa",
					categoryid: 123081,
					chaindata: [{
							id: 123088511,
							name: "智慧医2"
						}, {
							id: 12773012,
							name: "康复医疗12"
						},
						{
							id: 123013,
							name: "基因检测12"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗2"
						}, {
							id: 1230711,
							name: "互联网医疗12"
						},
						{
							id: 1230912,
							name: "辅助生殖12"
						}, {
							id: 1230193,
							name: "医疗大数据12"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗12"
						},
						{
							id: 123014,
							name: "宠物医疗12"
						}, {
							id: 1230175,
							name: "医疗废品处理12 "
						}, {
							id: 12301441,
							name: "独立医学实验服务12 "
						}, {
							id: 123012,
							name: "医疗信息化1"
						}, {
							id: 1230913,
							name: "远程医疗21"
						}
					]
				},
				{
					name: "医药sa",
					categoryid: 123061,
					chaindata: [{
							id: 1230151,
							name: "智慧医23"
						}, {
							id: 12773012,
							name: "康复医疗123"
						},
						{
							id: 123013,
							name: "基因检测123"
						}, {
							id: 1230184,
							name: "医疗美容1"
						}, {
							id: 123015,
							name: "口腔医疗2"
						}, {
							id: 1230511,
							name: "互联网医疗123"
						},
						{
							id: 1239012,
							name: "辅助生殖123"
						}, {
							id: 1230193,
							name: "医疗大数据12"
						}, {
							id: 1230414,
							name: "干细胞治疗1"
						}, {
							id: 1230183,
							name: "远程医疗12"
						},
						{
							id: 123014,
							name: "宠物医疗123"
						}, {
							id: 1230153,
							name: "医疗废品处理123 "
						}, {
							id: 1230141,
							name: "独立医学实验服务123 "
						}, {
							id: 123012,
							name: "医疗信息化13"
						}, {
							id: 1230913,
							name: "远程医疗213"
						}
					]
				},
			]
		}
	];

	export default {
		name: 'investmentdata',
		data() {
			return {
				msg: "产业机会",
				categoryid: 0,
				categoryid1: 0,
				chainid:0,
				cetagroylist: [],
				secondlist: [],
				thirdclist: [],
				chainids: [],
				marketopprlist: [],
			}
		},
		created() {
			var _this = this;
			this.categoryid = this.$route.params.categoryid ? this.$route.params.categoryid : 0;
			this.categoryid1 = this.$route.params.categoryidsm ? this.$route.params.categoryidsm : 0;
			this.categroylistfun();
			this.showsecondlist(this.categoryid);
			this.showthirdlist(this.categoryid1);
		 


		},
		mounted() {
			// console.log(this.$route.params.categoryid)
			var _this = this;

		},
		methods: {
			routerTo(name, datas) {
				this.$router.push({
					name: name,
					params: datas
				});
			},
			categroylistfun: function() {
				var _this = this;
				_this.cetagroylist = datalist1;
			}, 
			showsecondlist: function(id) {
				var _this = this;
				for (var i = 0; i < _this.cetagroylist.length; i++) {
					var items = _this.cetagroylist[i];
					if (items.categoryid == id) {
						_this.secondlist = items.data;
					}
				}
				_this.chainids = [];
				 
			},
			showthirdlist: function(id) {
				var _this = this;
				for (var i = 0; i < _this.secondlist.length; i++) {
					var items = _this.secondlist[i];
					if (items.categoryid == id) {
						_this.thirdclist = items.chaindata;
					}
				}
				for (var i = 0; i < _this.thirdclist.length; i++) {
					var items = _this.thirdclist[i];
					items.ischecks = false;
				}
				_this.chainids = [];
				 
			},
			chainidshow: function(id) { 
				var _this = this;
			_this.chainid=id;
				console.log(id); 
			}
		}
	}
</script>

<style>
</style>
